import { VehicleInfo } from '@@partner:types:app'
import React from 'react'

import { useFetchAllVehicles } from '@@partner:graphql/query/vehicle/allVehicles.gql'

import VehiclesTable from './VehiclesTable'

import { useGridHelper } from '@@partner:helpers/crud/grid'
import LogisticTopMenu from '../LogisticTopMenu'
import VehiclesFilter from './VehiclesFilter'
import { generatePath, useHistory, useParams } from 'react-router-dom'
import { ROUTE_LOGISTIC_VEHICLES_SINGLE } from '@@partner:config/routes'



export default function VehiclesList () {
  const { brandSlug } = useParams<any>()
  const history = useHistory()
  const { page, tableSort, filter, handlePageSelect, handleSortColumn, handleFilterChanged } =
    useGridHelper({
      defaultSortFieldName: 'created_at',
      defaultSortDirection: 0,
      defaultSortType: 'desc',
      defaultLimit: 20,
      defaultLimitOptions: [ 10, 20, 50, 100 ],
      defaultFilter: {}
    })

  const handleOpenVehicle = (vehicle: VehicleInfo) => {
    history.push(generatePath(ROUTE_LOGISTIC_VEHICLES_SINGLE, {
      brandSlug,
      vehicleId: vehicle.id
    }))
    // Handle opening the vehicle details
  }

  const { vehicles, loading, error } = useFetchAllVehicles({
    filter,
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    },
    pager: {
      page
    }
  })


  return (
    <div>
      <VehiclesFilter onFilterChanged={handleFilterChanged} />

      <VehiclesTable
        vehicles={vehicles}
        loading={loading}
        onOpenVehicle={handleOpenVehicle}
        onPageSelect={handlePageSelect}
        onSortColumn={handleSortColumn}
        tableSort={tableSort}
        page={page}
        error={error}
      />
    </div>
  )
}